var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoopStart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 88,
    viewBox: "0 0 72 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0H65C68.866 0 72 3.13401 72 7C72 10.866 68.866 14 65 14H64.5C60.3579 14 57 17.3579 57 21.5V52.5C57 56.6421 60.3579 60 64.5 60C68.6421 60 72 63.3579 72 67.5V78C72 83.5229 67.5229 88 62 88H51H40C17.9086 88 0 70.0914 0 48V40Z",
    fill: "#C4C4C4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoopStart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LoopStart.665b88103ed94180a82040f09fbffa8d.svg";